import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class PosDiscountPlanService {
    private baseURL: string;

    constructor(private http: HttpClient) {
        this.baseURL = environment.apiBaseUrl;
    }

    // Get all discount plans for a vendor 
    getPOSDiscountPlans(vendorId: number): Observable<any> {
        return this.http.get<any>(
            `${this.baseURL}/Vendor/GetPOSDiscountPlans?vendorId=${vendorId}`,
            { observe: 'response' }
        ).pipe(
            map((res: HttpResponse<any>) => res.body || []),
            catchError(this.handleError)
        );
    }

    // Save (Add/Update multiple) discount plans for a vendor
    savePOSDiscountPlans(request: any): Observable<any> {
        return this.http.post<any>(
            `${this.baseURL}/Vendor/SavePOSDiscountPlans`,
            request,
            { observe: 'response' }
        ).pipe(
            map((res: HttpResponse<any>) => res.body),
            catchError(this.handleError)
        );
    }

    // Common error handler
    private handleError(error: HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
            return throwError(() => error.error.message);
        }
        return throwError(() => error.message || 'Server error');
    }
}
